/*
 * Copyright (C) 2025 SimpliCity Digital Inc - All Rights Reserved
 */

import React from "react";
// import { RichText } from "@simplicitycms/simplicity-richtext";
// import { RichTextImage } from 'cms/shared/images/rich-text-image'
import { ScrollAnimation } from "./ScrollAnimation";
import "./styles.css";

const ScrollRevealImage = (props) => {

    let component = props?.component;
    let richtext = component?.richtext;
    let image = component?.image;
    let settings = component?.settings;
    // let side = component?.side ?? "left";
    // let displayWidth = component?.displayWidth;
    // let displayHeight = component?.displayHeight;
    // object-fit: cover;

    // const orientation = (displayWidth > displayHeight) ? 'horizontal' : 'vertical'
    return (
        <div className="simplicity-scroll-reveal top-section">
            {image && (
                <>
                    {/*<div*/}
                    {/*    className={`simplicity-scroll-reveal-inner`}*/}
                    {/*>*/}
                    <ScrollAnimation
                        image={image}
                        settings={settings}
                        richtext={richtext}
                    />

                    {/*<RichTextImage*/}
                    {/*    width={displayWidth}*/}
                    {/*    height={displayHeight}*/}
                    {/*    image={image}*/}
                    {/*    settings={settings}*/}
                    {/*    orientation={orientation}*/}
                    {/*/>*/}
                    {/*</div>*/}
                </>
            )}
            {/*<div className="rich-text-wrap read-only">*/}
            {/*    <RichText richtext={richtext} />*/}
            {/*</div>*/}
        </div>
    );
};

ScrollRevealImage.displayName = "ScrollRevealImage";
export { ScrollRevealImage };
